import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=d6787b44&scoped=true&"
import script from "./Rule.vue?vue&type=script&lang=ts&"
export * from "./Rule.vue?vue&type=script&lang=ts&"
import style0 from "./Rule.vue?vue&type=style&index=0&id=d6787b44&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6787b44",
  null
  
)

export default component.exports